import { Fingerprint } from 'lucide-react';

export interface ExternalIdentifiersCardProps {
  externalSource: string | null;
  externalUserId: string | null;
}

export function ExternalIdentifiersCard({
  externalSource,
  externalUserId,
}: ExternalIdentifiersCardProps) {
  if (!externalSource && !externalUserId) return null;

  return (
    <div className="rounded-xl border border-border bg-card px-4 py-3.5">
      <div className="flex items-center gap-1.5 text-muted-foreground">
        <span className="inline-flex h-4 w-4 items-center justify-center rounded-md bg-secondary text-muted-foreground">
          <Fingerprint className="h-3.5 w-3.5" strokeWidth={1.6} />
        </span>
        <span className="text-[10.5px] font-medium uppercase tracking-[0.1em]">
          External identifiers
        </span>
      </div>
      <dl className="mt-2.5 flex flex-wrap gap-x-6 gap-y-2">
        {externalSource && (
          <div className="flex flex-col gap-0.5">
            <dt className="text-[10.5px] font-medium uppercase tracking-[0.08em] text-muted-foreground/70">
              Source
            </dt>
            <dd className="font-mono text-[13.5px] text-foreground/90">{externalSource}</dd>
          </div>
        )}
        {externalUserId && (
          <div className="flex flex-col gap-0.5">
            <dt className="text-[10.5px] font-medium uppercase tracking-[0.08em] text-muted-foreground/70">
              User ID
            </dt>
            <dd className="font-mono text-[13.5px] text-foreground/90">{externalUserId}</dd>
          </div>
        )}
      </dl>
    </div>
  );
}
